import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';
import {Element} from 'react-scroll';

import log_blanco from '../../../assets/images/sitio/03_Patrocinadores_sitio_IES/Ies_Tci.png';


import banner from '../../../assets/images/2022/stands/interiores/completos/stands_ind_TCI.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_v.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_v.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_v.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_v.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_v.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_v.png';
import btn_yt from '../../../assets/images/sitio/pantalla_patrocinadores/iconos_botones_patrocinios_IES/ies_youtube_azul.png';
import btn_yt_hover from '../../../assets/images/sitio/pantalla_patrocinadores/iconos_botones_patrocinios_IES/ies_youtube_azul.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_v.png';


const Tci = (props) => {
  const { Panel } = Collapse;
  const { idioma, onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);
  //let navigate = useNavigate();

  return (
    <>
      <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
      </Row>
      <Row>
      <Col span={24} offset={0}>
        <a href="#video" onClick={()=>{onMetrica('video',nombre)}}>
          <img src={banner} style={{width:'100%'}} />
        </a>
        <br /><br />
        </Col>
        <Col span={20} offset={2}>
          {idioma === 'es' ?
          <p className="texto_patrocinadores">
            <span className='color_verde'><strong>SOBRE NOSOTROS</strong></span>
            <br />
          TCI produce componentes para la fabricación de luminarios: Drivers, Módulos LED, COBs y Sistemas Inalámbricos. Puedes consultar nuestros productos en: <a target="_blank" className="texto_patrocinadores_link" href="https://www.tci.it/en/">aquí</a>.
          <br /><br />
          En México somos relativamente nuevos, pero TCI tiene casi 40 años fabricando controladores para iluminación y dispositivos electrónicos de telecomunicaciones.
          <br />
          Cuenta con 400 empleados en una superficie de 50,000 m2 en Italia.
        </p>
        :
        <p className="texto_patrocinadores">
          <span className='color_verde'><strong>ABOUT OUS</strong></span>
          TCI produces components for the manufacture of luminaires: Drivers, LED Modules, COBs and Wireless Systems. You can check our products at: <a target="_blank" className="texto_patrocinadores_link" href="http://tci.it">here</a>.
          <br /><br />
          n Mexico we are relatively new, but TCI has almost 40 years manufacturing controllers for lighting and electronic telecommunications devices.
          <br />
          It has 400 employees on an area of 50,000 m2 in Italy.
        </p>
        }
        </Col>

        <Element name="#video"/>
        <Col span={16} offset={4} onClick={()=>onMetrica('video',nombre)}>
        <br />
        <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/dqERPIWQdNM?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          
          <br /><br />
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:4}} className="paddin_20">
          {idioma === 'es' ?
          <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525584213606&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20TCI%20de%20la%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" /></a>
        :
        <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525584213606&text=Hello,%20contact%20me%20from%20the%20TCI%20stand%20of%20the%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20">
        {idioma === 'es' ?
        <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:comercial@grupogcm.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_email_hover : img_email} style={{width:'100%'}} alt="video" /></a>
      :
      <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="mailto:comercial@grupogcm.com" onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_email_en_hover : img_email_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
        {idioma === 'es' ?
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        :
        <p className="titulo_patrocinador_texto">FREQUENT QUESTIONS</p>
        }
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ?
            <Panel header="¿Qué garantía ofrece TCI?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  TCI garantiza sus productos hasta por 10 años.
                  </p>
            </Panel>
            :
            <Panel header="What guarantee does TCI offer?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  TCI guarantees its products for up to 10 years.
                  </p>
            </Panel>}
           {idioma === 'es' ?
            <Panel header="¿Qué luminarios incluyen componentes TCI?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Aunque en México TCI es relativamente nueva, es la marca de LEDs y drivers más utilizada por los fabricantes europeos. Sus componentes están presentes dentro de una gran cantidad de productos de alta especificación, como iGuzzini, FLOS, Zumtobel, Trilux y Delta Light, entre otras marcas de luminarios líderes en todo el mundo.
                  <br />
                  Además, hay una amplia base de instalaciones con componentes TCI en México, como las remodelaciones de los pisos de venta de las cadenas Soriana, Coppel o Casa Ley, a través de diversos fabricantes locales, por ejemplo: HighLumen, Estevez, Italli, Zeraus, Luxmart y AlpinLED.
                  </p>
            </Panel>
            :
            <Panel header="What luminaires include TCI components?" key="2" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Although TCI is relatively new in Mexico, it is the brand of LEDs and drivers most used by European manufacturers. Its components are present in a large number of highly selected products, such as iGuzzini, FLOS, Zumtobel, Trilux and Delta Light, among other leading lighting brands around the world.
            <br />
            In addition, there is a wide base of installations with TCI components in Mexico, such as the remodeling of the sales floors of the Soriana, Coppel or Casa Ley chains, through various local manufacturers, for example: HighLumen, Estevez, Italli, Zeraus, Luxmart and AlpinLED.
            </p>
      </Panel>}
           {idioma === 'es' ? 
           <Panel header="¿En dónde puedo comprar TCI?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Los productos TCI se comercializan en México a través de GCM Comercial, puedes contactarte con Miguel Cañedo al email: <a target="_blank" href="mailto:comercial@grupogcm.com">comercial@grupogcm.com</a>
                  </p>
            </Panel>
            :
            <Panel header="Where can I buy TCI?" key="3" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            TCI products are marketed in Mexico through GCM Comercial, you can contact Miguel Cañedo at the email: <a target="_blank" href="mailto:comercial@grupogcm.com">comercial@grupogcm.com</a>
            </p>
      </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Cuál es la página web de TCI?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a target="_blank" className="texto_patrocinadores_link" href="http://tci.it">http://tci.it</a>
                  </p>
            </Panel>
            :
            <Panel header="What is the TCI website?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a target="_blank" className="texto_patrocinadores_link" href="http://tci.it">http://tci.it</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Me pueden mandar más información?" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Claro! deja tus datos en este enlace: <a target="_blank" className="texto_patrocinadores_link" href="http://bit.ly/tci-contacto">http://bit.ly/tci-contacto</a>
                  </p>
            </Panel>
            :
            <Panel header="Can you send me more information?" key="5" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Of course! leave your information in this link: <a target="_blank" className="texto_patrocinadores_link" href="http://bit.ly/tci-contacto">http://bit.ly/tci-contacto</a>
                  </p>
            </Panel>}
            {idioma === 'es' ? 
              <Panel header="Catálogo de LEDs" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a target="_blank" className="texto_patrocinadores_link" href="https://grupogcm.com/datasheets/tci/TCI-LED.pdf">https://grupogcm.com/datasheets/tci/TCI-LED.pdf</a>
                  </p>
            </Panel>
            :
            <Panel header="LED Catalog" key="6" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a target="_blank" className="texto_patrocinadores_link" href="https://grupogcm.com/datasheets/tci/TCI-LED.pdf">https://grupogcm.com/datasheets/tci/TCI-LED.pdf</a>
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="Catálogo de COBs" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                    <a target="_blank" className="texto_patrocinadores_link" href="https://grupogcm.com/datasheets/tci/TCI-COB.pdf">https://grupogcm.com/datasheets/tci/TCI-COB.pdf</a>
                  </p>
            </Panel>
            :
            <Panel header="COBs Catalog" key="7" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                    <a target="_blank" className="texto_patrocinadores_link" href="https://grupogcm.com/datasheets/tci/TCI-COB.pdf">https://grupogcm.com/datasheets/tci/TCI-COB.pdf</a>
                  </p>
            </Panel>
            }
            {idioma === 'es' ?
            <Panel header="Catálogo de Drivers" key="8" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a target="_blank" className="texto_patrocinadores_link" href="https://grupogcm.com/datasheets/tci/TCI-Drivers.pdf">https://grupogcm.com/datasheets/tci/TCI-Drivers.pdf</a>
                  </p>
            </Panel>
            :
            <Panel header="Drivers Catalog" key="8" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  <a target="_blank" className="texto_patrocinadores_link" href="https://grupogcm.com/datasheets/tci/TCI-Drivers.pdf">https://grupogcm.com/datasheets/tci/TCI-Drivers.pdf</a>
                  </p>
            </Panel>}
          </Collapse>
        </Col>
        <Col span={20} offset={2}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}>
        
        <Row justify='center'>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)} href="https://www.facebook.com/tcisrl" target="_blank" onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_fb_hover : btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('twitter',nombre)} href="" target="_blank"><img src={btn_tw} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)} href="" target="_blank"><img src={btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)} href="https://www.instagram.com/simonelectricmx/" target="_blank" onMouseEnter={()=>setHoverRedes(2)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 2 ? btn_in_hover : btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Tci;